import EditarPaciente from '../components/Pacientes/AdicionarPaciente.vue'

let routes = {
    path: '/paciente',
    component: resolve => require(['../components/layout/HeaderAndLeftNavBar.vue'], resolve),
    children: [
        {
            path: '/editar-paciente/:id?',
            name: 'EditarPaciente',
            component: EditarPaciente
        },
    ]
};


export default routes


// WEBPACK FOOTER //
// ./src/router/editar_paciente.js